import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobPaymentEmailTemplate.List.IRequest;
type Response = Api.Core.ClaimJobPaymentEmailTemplate.List.IResponse;
type Headers = Api.Core.ClaimJobPaymentEmailTemplate.List.IHeaders;
const url = '/api/Management/ClaimJobPaymentEmailTemplate';
export default async function claimJobPaymentEmailTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
